// extracted by mini-css-extract-plugin
export default {"greeting":"OrderType_greeting__UJjuD","header":"OrderType_header__x+U3k","cards":"OrderType_cards__-vt4M"};